import {
  Button,
  Card,
  Switch,
  Table,
  Tooltip,
  Form,
  Input,
  Modal,
  Row,
  Col,
  DatePicker,
  Image,
  Select,
} from "antd";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import Plus from "../../../assets/images/plus.svg";
import DeleteModal from "../../../components/DeleteModal";
import apiPath from "../../../constants/apiPath";
import { DeleteCustomerReasons } from "../../../constants/reasons";
import { AppStateContext } from "../../../context/AppContext";
import lang from "../../../helper/langHelper";
import { Severty, ShowToast } from "../../../helper/toast";
import useDebounce from "../../../hooks/useDebounce";
import useRequest from "../../../hooks/useRequest";
import AddFrom from "./AddFrom";
import { useNavigate } from "react-router";
import ViewWallet from "./ViewProgress";
import SendNotification from "../../../components/SendNotification";
import prouser from "../../../assets/images/avatar-1.png"

const { RangePicker } = DatePicker;

function Index() {
  const heading = "Customers Manager";
  const { setPageHeading } = useContext(AppStateContext);
  const Search = Input.Search;
  const sectionName = lang("Customer");
  const urlParams = new URLSearchParams(window.location.search);
  const path = urlParams.get("status");

  const api = {
    status: apiPath.statusCustomer,
    addEdit: apiPath.addEditCustomer,
    list: apiPath.listCustomer,
    delete: apiPath.listCustomer,
    addMoney: apiPath.addMoney,
  };

  const [searchText, setSearchText] = useState("");
  const { request } = useRequest();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [visible, setVisible] = useState(false);
  const [selected, setSelected] = useState();
  const [showDelete, setShowDelete] = useState(false);
  const [showStatus, setShowStatus] = useState(false);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const debouncedSearchText = useDebounce(searchText, 300);
  const [send, setSend] = useState(false);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [status, setStatus] = useState();
  const [columnFilter, setColumnFilter] = useState();
  const navigate = useNavigate();
  const onSearch = (e) => {
    setSearchText(e.target.value);
    setPagination({ ...pagination, current: 1 });
  };

  const onDelete = (id) => {
    request({
      url: api.delete + "/" + id,
      method: "DELETE",
      onSuccess: (data) => {
        setLoading(false);
        setRefresh((prev) => !prev);
        ShowToast(data.message, Severty.SUCCESS);
      },
      onError: (error) => {
        setLoading(false);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const onSend = (id) => {
    request({
      url: api.delete + "/" + id,
      method: "DELETE",
      onSuccess: (data) => {
        setLoading(false);
        setRefresh((prev) => !prev);
        ShowToast(data.message, Severty.SUCCESS);
      },
      onError: (error) => {
        setLoading(false);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const handleChangeStatus = (id, message) => {
    request({
      url: api.list + "/status/" + id,
      method: "PUT",
      data: { message },
      onSuccess: (data) => {
        setLoading(false);
        setRefresh((prev) => !prev);
        ShowToast(data.message, Severty.SUCCESS);
      },
      onError: (error) => {
        console.log(error);
        setLoading(false);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const columns = [
    {
      title: "Image",
      dataIndex: "image",
      key: "image",
      width: 200,
      render: (_, { image }) => {
        let url = image?.includes("http") ? image : "https://dunnnit.s3.me-central-1.amazonaws.com/dunnnit/" + image;
        console.log(url)
        return image ? (
          <span>
            <img width={40} src={url} />{" "}
          </span>
        ) : (
          <span>
            <img width={40} src={image ? url : prouser} />{" "}
          </span>
        );
      },
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: 200,
      sorter: (a, b) => a?.name?.localeCompare(b?.name),
      render: (_, { name }) => {
        return name ? name : "-";
      },
    },
    {
      title: "Phone Number",
      sorter: (a, b) => a?.mobile_number?.localeCompare(b?.mobile_number),
      render: (_, { mobile_number, country_code }) => {
        return (
          (country_code
            ? country_code?.includes("+")
              ? country_code + "-"
              : `+${country_code}-`
            : "+968") + (mobile_number ? mobile_number : "")
        );
      },
    },
    {
      title: "Email ID",
      dataIndex: "email",
      key: "email",
      sorter: (a, b) => a?.email?.localeCompare(b?.email),
      render: (_, { email }) => {
        return email ? (
          <span style={{ textTransform: "lowercase" }}>{email}</span>
        ) : (
          "-"
        );
      },
    },
    {
      title: "checked-In Emotion",
      dataIndex: "checkedInEmotionCount",
      key: "checkedInEmotionCount",
      width: 200,
      sorter: (a, b) => (a?.checkedInEmotionCount || 0) - (b?.checkedInEmotionCount || 0),
      render: (_, { checkedInEmotionCount }) => {
        return checkedInEmotionCount ? checkedInEmotionCount : "0";
      },
    },
    {
      title: "Challenges Count",
      dataIndex: "challenges_count",
      key: "challenges_count",
      width: 200,
      sorter: (a, b) => (a?.challenges_count || 0) - (b?.challenges_count || 0),
      render: (_, { challenges_count }) => {
        return challenges_count ? challenges_count : "0";
      },
    },
    {
      title: "Completed Challenges Count",
      dataIndex: "completedChallengesCount",
      key: "completedChallengesCount",
      width: 200,
      sorter: (a, b) => (a?.completedChallengesCount || 0) - (b?.completedChallengesCount || 0),
      render: (_, { completedChallengesCount }) => {
        return completedChallengesCount ? completedChallengesCount : "0";
      },
    },
    {
      title: "Level",
      dataIndex: "level",
      key: "level",
      width: 200,
      sorter: (a, b) => (a?.level || 0) - (b?.level || 0),
      render: (_, { level }) => {
        return level ? level : "0";
      },
    },
    {
      title: "Number of slots",
      dataIndex: "slot",
      key: "slot",
      width: 200,
      sorter: (a, b) => (a?.slot || 0) - (b?.slot || 0),
      render: (_, { slot }) => {
        return slot ? slot : "0";
      },
    },
    {
      title: "subscription",
      dataIndex: "is_subscription",
      key: "is_subscription",
      width: 200,
      render: (_, { is_subscription }) => {
        return is_subscription ? "Yes" : "No";
      },
    },
    {
      title: "Status",
      key: "is_active",
      dataIndex: "is_active",
      className: "driver-status",
      render: (_, { _id, is_active }) => {
        return (
          <Switch
            onChange={() => {
              handleChangeStatus(_id);
            }}
            checked={is_active}
          />
        );
      },
      filters: [
        {
          text: "Active",
          value: true,
        },
        {
          text: "Inactive",
          value: false,
        },
      ],
    },
    {
      title: "Added On",
      key: "created_at",
      dataIndex: "created_at",
      render: (_, { created_at }) => {
        return moment(created_at).format("ll");
      },
    },
    {
      title: "Action",
      fixed: "right",
      key: "action",
      render: (_, record) => {
        return (
          <div div className="d-flex justify-contenbt-start">
            <Tooltip title={"View"} color={"purple"} key={"view"}>
              <Button
                className="edit-cls btnStyle primary_btn"
                onClick={() => {
                  setSelected(record);
                  navigate(`/customer/view/${record._id}`);
                }}
              >
                <i style={{ color: "fff" }} class="far fa-eye"></i>
              </Button>
            </Tooltip>

            <Tooltip title={"Edit"} color={"purple"} key={"edit"}>
              <Button
                className="edit-cls btnStyle primary_btn"
                onClick={() => {
                  setSelected(record);
                  setVisible(true);
                }}
              >
                <i style={{ color: "fff" }} class="far fa-edit"></i>
              </Button>
            </Tooltip>

            <Tooltip title={"Send"} color={"purple"} key={"send"}>
              <Button
                className="edit-cls btnStyle primary_btn"
                onClick={() => {
                  setSelected(record);
                  setSend(true);
                }}
              >
                <i style={{ color: "fff" }} class="fa fa-paper-plane"></i>
              </Button>
            </Tooltip>

            <Tooltip title={"Delete"} color={"purple"} key={"Delete"}>
              <Button
                className="btnStyle deleteDangerbtn"
                onClick={() => {
                  setSelected(record);
                  setShowDelete(true);
                }}
              >
                <i
                  style={{ fontSize: "small", color: "fff" }}
                  class="fa fa-light fa-trash"
                ></i>
              </Button>
            </Tooltip>
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    fetchData({ ...pagination, current: 1 });
  }, [refresh, debouncedSearchText, startDate, endDate]);

  useEffect(() => {
    setPageHeading(heading);
  }, [setPageHeading]);

  const fetchData = (pagination, filters, sorter) => {
    const filterActive = filters ? filters.is_active : columnFilter?.is_active;
    setLoading(true);

    request({
      url:
        api.list +
        `?status=${filterActive ? filterActive.join(",") : ""}&page=${pagination ? pagination.current : 1
        }&pageSize=${pagination ? pagination.pageSize : 10
        }&search=${debouncedSearchText}&start_date=${startDate ? startDate : ""
        }&end_date=${endDate ? endDate : ""}${path ? `&status=1` : ""}${sorter ? `&${sorter}` : ""}`,
      method: "GET",
      onSuccess: (data) => {
        setLoading(false);
        setList(data.data?.data);
        setPagination((prev) => ({
          ...prev,
          current: pagination.current,
          pageSize: pagination?.pageSize,
          total: data?.data?.total,
        }));
      },
      onError: (error) => {
        setLoading(false);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const handleChange = (pagination, filters, sorter) => {
    const { field, order } = sorter;

    let query = undefined;
    if (field && order) {
      query = `${field}=${order}`;
    }
    setColumnFilter(filters)
    fetchData(pagination, filters, query);
  };

  const handleChangeDate = (e) => {
    if (e != null) {
      setStartDate(moment(e[0]._d).format("YYYY-MM-DD"));
      setEndDate(moment(e[1]._d).format("YYYY-MM-DD"));
    } else {
      setStartDate();
      setEndDate();
    }
  };

  return (
    <>
      <div className="tabled productCaralogue">
        <Row gutter={[24, 0]}>
          <Col xs="24" xl={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title={"Customers List"}
              extra={
                <>
                  <div className="button_group justify-content-end w-100">
                    {/* <Select
                      className="select-input"
                      onChange={(key) => setStatus(key)}
                      autoComplete="off"
                      placeholder="Select Challenge Category"
                    >
                      <Select.Option key={"completed"} value={"completed"}>
                        Completed
                      </Select.Option>
                      <Select.Option key={"current"} value={"current"}>
                        Ongoing
                      </Select.Option>
                      <Select.Option key={"drop"} value={"drop"}>
                        Drop Out
                      </Select.Option>
                    </Select> */}
                    <Search
                      allowClear
                      className="search-input"
                      size="large"
                      onChange={onSearch}
                      value={searchText}
                      onPressEnter={onSearch}
                      placeholder="Search By Name, email, number"
                      title="Search By Name, email, number"
                    />
                    <RangePicker
                      disabledDate={(current) => current.isAfter(Date.now())}
                      onChange={handleChangeDate}
                    />

                    <Button
                      className="primary_btn btnStyle"
                      onClick={(e) => {
                        setVisible(true);
                        setSearchText("");
                      }}
                    >
                      <span className="add-Ic">
                        <img src={Plus} />
                      </span>
                      {"Add"} {sectionName}
                    </Button>
                  </div>
                </>
              }
            >
              <div className="table-responsive customPagination">
                <Table
                  loading={loading}
                  columns={columns}
                  dataSource={list}
                  pagination={{
                    defaultPageSize: 10,
                    responsive: true,
                    total: pagination.total,
                    current: pagination?.current,
                    pageSize: pagination?.pageSize,
                  }}
                  onChange={handleChange}
                  className="ant-border-space"
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>

      {visible && (
        <AddFrom
          section={sectionName}
          api={api}
          show={visible}
          hide={() => {
            setSelected();
            setVisible(false);
          }}
          data={selected}
          refresh={() => setRefresh((prev) => !prev)}
        />
      )}

      {showDelete && (
        <DeleteModal
          title="Delete User"
          subtitle="Are you sure you want to delete this user?"
          show={showDelete}
          hide={() => {
            setShowDelete(false);
            setSelected();
          }}
          onOk={() => onDelete(selected?._id)}
          reasons={DeleteCustomerReasons}
        />
      )}

      {send && (
        <SendNotification
          api={api}
          title="Send Message"
          subtitle="Are you sure you want to send a message?"
          show={send}
          hide={() => {
            setSend(false);
            setSelected();
          }}
          onOk={() => console.log(selected?._id)}
          data={selected}
          refresh={() => setRefresh((prev) => !prev)}
        />
      )}
    </>
  );
}

export default Index;
